import React from "react";

import { useTranslation } from "react-i18next";

import { FormTextInput } from "@/uiKit/molecules/form/FormTextInput.tsx";

export type PatientHelperPhoneFormFieldProps = {
  name?: string;
  labelType?: "left" | "default";
  className?: string;
};

export const PatientHelperPhoneFormField: React.FC<PatientHelperPhoneFormFieldProps> = ({
  name = "helperPhone",
  labelType = "default",
  className,
}) => {
  const { t } = useTranslation();
  return (
    <FormTextInput
      id="patient-helper-phone-form-field"
      name={name}
      label={labelType === "default" ? t("form.helperPhone.placeholder") : t("form.helperPhone.label")}
      placeholder={t("form.helperPhone.placeholder")}
      autoComplete="section-helper tel"
      reserveErrorSpace
      className={className}
      labelType={labelType}
    />
  );
};
